<template>
	<component v-if="chosen" :is="componentOfPart(chosen)" :key="chosenIndex" :part="partRef(chosen)" :data="localData" :readonly="readonly" :viewmode="viewmode"></component>
</template>

<script setup lang="ts">
import {computed, defineProps} from "vue";
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Choose} from "@t/fd/layout/Choose";
import type {FormPartOrReference} from "@t/fd/FormPartOrReference";

const untypedProps = defineProps({
	...containerProps,
});
const props = untypedProps as ContainerProps;
const ch = computed<Choose>(() => props.part as Choose);
const {componentOfPart, partRef, localData, ro, vm, visible, visibilityEval} = useContainer(props);


const chosen = computed<FormPartOrReference | null>(() => {
	const idx = chosenIndex.value;
	if (idx >= 0) return ch.value.items[idx];
	return null;
});

const chosenIndex = computed<number>(() => {
	if (visible.value) {
		for (let i = 0; i < ch.value.tests.length; i++) {
			if (visibilityEval(ch.value.tests, i)) {
				return i;
			}
		}
	}
	return -1;
});

</script>

<style>
</style>
